import { render, staticRenderFns } from "./ClosedProjects.vue?vue&type=template&id=0d2cff8b&scoped=true"
import script from "./ClosedProjects.vue?vue&type=script&lang=js"
export * from "./ClosedProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2cff8b",
  null
  
)

export default component.exports